(function () {
  const DESKTOP_QUERY = '(min-width: 750px)';
  const HIDDEN_CLASS = 'is-hidden';

  function initContent(section) {
    const grid = section.querySelector('.ibscent-related__grid');
    const toggle = section.querySelector('.ibscent-related__toggle-btn');
    if (!grid || !toggle) return false;
    if (grid.dataset.ibscentRelatedReady === 'true') return true;
    grid.dataset.ibscentRelatedReady = 'true';

    const cards = Array.from(grid.querySelectorAll('.ibscent-coll-card'));
    const desktopThreshold = parseInt(section.dataset.initialVisibleDesktop, 10) || 4;
    const mobileThreshold = parseInt(section.dataset.initialVisibleMobile, 10) || 2;
    const desktopMedia = window.matchMedia(DESKTOP_QUERY);

    function applyVisibility() {
      const expanded = section.dataset.expanded === 'true';
      const threshold = desktopMedia.matches ? desktopThreshold : mobileThreshold;
      cards.forEach(function (card, index) {
        if (expanded || index < threshold) {
          card.classList.remove(HIDDEN_CLASS);
        } else {
          card.classList.add(HIDDEN_CLASS);
        }
      });
      const overThreshold = cards.length > threshold;
      toggle.hidden = !overThreshold;
    }

    function setExpanded(value) {
      section.dataset.expanded = value ? 'true' : 'false';
      toggle.setAttribute('aria-expanded', value ? 'true' : 'false');
      toggle.textContent = value
        ? toggle.dataset.showLessText || 'Show less'
        : toggle.dataset.showMoreText || 'Show more';
      applyVisibility();
      if (value) {
        const firstRevealed = cards.find(function (card) {
          return card.dataset.wasHidden === 'true' && !card.classList.contains(HIDDEN_CLASS);
        });
        if (firstRevealed) {
          const link = firstRevealed.querySelector('.ibscent-coll-card__title-link');
          if (link) link.focus({ preventScroll: true });
        }
      }
    }

    toggle.addEventListener('click', function () {
      const next = section.dataset.expanded !== 'true';
      cards.forEach(function (card) {
        card.dataset.wasHidden = card.classList.contains(HIDDEN_CLASS) ? 'true' : 'false';
      });
      setExpanded(next);
    });

    const mediaChangeHandler = function () {
      if (section.dataset.expanded === 'true') return;
      applyVisibility();
    };

    if (typeof desktopMedia.addEventListener === 'function') {
      desktopMedia.addEventListener('change', mediaChangeHandler);
    } else if (typeof desktopMedia.addListener === 'function') {
      desktopMedia.addListener(mediaChangeHandler);
    }

    applyVisibility();

    grid.querySelectorAll('[data-ibscent-quick-add]').forEach(initQuickAdd);

    return true;
  }

  function observeSection(section) {
    if (section.dataset.ibscentRelatedObserver === 'true') return;
    section.dataset.ibscentRelatedObserver = 'true';

    if (initContent(section)) return;

    const observer = new MutationObserver(function () {
      if (initContent(section)) {
        observer.disconnect();
      }
    });
    observer.observe(section, { childList: true, subtree: true });
  }

  function initQuickAdd(form) {
    if (form.dataset.ibscentQuickAddReady === 'true') return;
    form.dataset.ibscentQuickAddReady = 'true';

    const button = form.querySelector('.ibscent-related__quick-add-btn');
    const label = form.querySelector('.ibscent-related__quick-add-label');
    if (!button || !label) return;

    const defaultText = button.dataset.defaultText || 'Add to cart';
    const addedText = button.dataset.addedText || 'Added';
    const soldOutText = button.dataset.soldoutText || 'Unavailable';
    const errorText = button.dataset.errorText || 'Try again';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      submitForm(form, button, label, { defaultText, addedText, soldOutText, errorText });
    });
  }

  function submitForm(form, button, label, texts) {
    if (button.disabled) return;
    button.disabled = true;
    const originalText = label.textContent;

    const formData = new FormData(form);
    fetch(form.action, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) {
        if (response.status === 422) {
          label.textContent = texts.soldOutText;
          setTimeout(function () {
            label.textContent = originalText || texts.defaultText;
            button.disabled = false;
          }, 2000);
          return null;
        }
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json().catch(function () {
          return {};
        });
      })
      .then(function (data) {
        if (!data) return;
        label.textContent = texts.addedText;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
        document.dispatchEvent(new CustomEvent('ibscent:cart:item-added', { detail: data }));
        setTimeout(function () {
          label.textContent = originalText || texts.defaultText;
          button.disabled = false;
        }, 1500);
      })
      .catch(function () {
        label.textContent = texts.errorText;
        setTimeout(function () {
          label.textContent = originalText || texts.defaultText;
          button.disabled = false;
        }, 2000);
      });
  }

  function bootstrap() {
    document.querySelectorAll('product-recommendations.ibscent-related').forEach(observeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('product-recommendations.ibscent-related');
    if (section) observeSection(section);
  });
})();
